import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const buttonGroup = css`
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;

  button:not(:first-child) {
    margin-left: 40px;
  }
`;

export const deleteButton = css`
  cursor: pointer;
  margin: auto 0 auto 40px;
  color: ${colors.error.default};

  :hover {
    color: ${colors.error.hover};
  }

  && {
    font-size: ${fonts.size.larger};
  }
`;
